/**
 * Created by Gaplo917 on 15/8/2017.
 */
import * as PIXI from 'pixi.js'
import * as _ from "lodash";

function loadSpriteSheetsTextures(resources, config){
  if(Array.isArray(config.json)){
    return _.flatMapDeep(
      config.json.map(( any,i) => {
        return _.values(resources[`${config.id}-${i}`].textures)
      })
    )
  }
  else {
    return _.values(resources[config.id].textures)
  }
}

export default class CustomAnimatedSprite extends PIXI.Container {
  /**
   * @param x
   * @param y
   * @param resources
   * @param config SpriteSheet Config
   * SpriteSheet Config Sample
   *
   * hedgehogAll: {
   *    id: 'hedgehog_all.png',
   *    json: ['static/spritesheet/hedgehog_all-0.json', 'static/spritesheet/hedgehog_all-1.json'],
   *    animationSpeed: 0.2,
   *    animations: {
   *      // key : 'prefix of images'
   *      effect1: 'hedgehog_effect01',
   *      effect2: 'hedgehog_effect02',
   *      effect3: 'hedgehog_effect03',
   *      effect4: 'hedgehog_effect04',
   *      effect5: 'hedgehog_effect05',
   *      effect7: 'hedgehog_effect07',
   *      effect8: 'hedgehog_effect08',
   *      effectIdle: 'hedgehog_effect_idle',
   *      effectRolling: 'hedgehog_effect_rolling',
   *    }
   *  },
   */
  constructor(x,y, resources, config){
    super()
    if(config.id && resources[config.id] && resources[config.id].spineData){
      this.isSpine = true
      const spine = new PIXI.spine.Spine(resources[config.id].spineData)

      spine.state.timeScale = config.timeScale || 1.0

      const localRect = spine.getLocalBounds()
      spine.position.set(-localRect.x / 2, -localRect.y / 2)
      spine.state.setEmptyAnimations()
      this._spine = spine

      this.addChild(spine)
    } else {
      this.isSpine = false
      // by design in BaseGame.loadImages, `resources[R.spriteSheets.xxx.id].textures` return the frames key-value arrays
      // need to flatten it and sort it
      const textures = _.sortBy(loadSpriteSheetsTextures(resources, config), (a,b) => {
        return a.textureCacheIds[0]
      })

      const animatedSprites = {}

      _.each(config.animations, (prefix) => {
        const targetTextures = textures.filter(t => t.textureCacheIds[0].startsWith(prefix))

        const animatedSprite = new PIXI.extras.AnimatedSprite(targetTextures)

        animatedSprite.animationSpeed = config.animationSpeed
        animatedSprite.x = 0
        animatedSprite.y = 0
        animatedSprite.anchor.x = 0.5
        animatedSprite.anchor.y = 0.5

        animatedSprites[prefix] = animatedSprite
      })

      this.textures = textures
      this.animatedSprites = animatedSprites
    }


    this.x = x
    this.y = y
    this.config = config
  }

  /**
   * @returns {PIXI.spine.Spine | *}
   */
  get spine(){
    return this._spine
  }

  frameAt(index){
    if(this.isSpine) throw new Error("Spine not support frameAt function")
    return this.textures[index]
  }

  _stopAllAnimation(){
    if(this.isSpine){
      // nothing needed
    } else {
      _.each(this.animatedSprites, (as) => {
        as.stop()
      })
    }


    this.removeChildren()
  }

  stopAnimation(prefix, removeFromContainer = true) {
    if(this.isSpine){
      const spine = this._spine
      spine.state.clearTracks()

      if(removeFromContainer){
        this.removeChild(this._spine)
      }
    } else {
      const animatedSprite = this.animatedSprites[prefix]
      animatedSprite.stop()

      if(removeFromContainer){
        this.removeChild(animatedSprite)
      }
    }

  }

  playAnimation(prefix, loop = false, onComplete = () => {}){

    if(this.isSpine){
      const spine = this._spine
      let trackIndex = prefix.track || 0
      let animationName = prefix.name || prefix

      if(spine.state.hasAnimation(animationName)) {
        requestAnimationFrame(() => {
          spine.state.setAnimation(trackIndex, animationName, loop)
          spine.state.tracks[trackIndex].listener = {
            complete: onComplete
          }
        })
      } else {
        console.warn(`No animation with ${prefix} in ${this.config} `)
        onComplete()
      }

    } else {
      // stop all animation first
      this._stopAllAnimation()

      const animatedSprite = this.animatedSprites[prefix]
      this.addChild(animatedSprite)

      console.log(`play animation repeat ${loop}`,animatedSprite)
      animatedSprite.loop = loop

      animatedSprite.onComplete = onComplete

      // start the animation
      requestAnimationFrame(() => {
        animatedSprite.gotoAndPlay(0)
      })
    }


  }

}



// WEBPACK FOOTER //
// ./src/game/objects/CustomAnimatedSprite.js